export const customTableNotation = {
  localeText: {
    sum: 'Σ ',
    max: 'MAX ',
    min: 'MIN ',
    count: 'COUNT ',
    avg: 'AVG ',
    rowGroupColumnsEmptyMessage: ' ', // replaced icon with message text in order to show it at all times
    func: 'Σ ', // TODO: will need to change if we add more functions
    irr: 'IRR',
    irrAggFunc: 'IRR',
    latestValue: 'Latest Value',
    moic: 'MOIC',
    moicAggFunc: 'MOIC',
    moicGeneric: 'MOIC',
    moicTotalCost: 'MOIC Total Cost',
    netMoic: 'Net MOIC',
    realizedMOIC: 'Realized MOIC',
    realizedMOICWithEscrow: 'Realized MOIC with Escrow',
    ownerShipPercentage: 'Ownership Percentage',
    unrealizedMOIC: 'Unrealized MOIC',
    captableOwnershipAggFunc: 'Ownership %',
    captableOutstandingOwnershipAggFunc: 'Ownership %',
  },
};
